import { component_tool, utils_tool } from '../../../tool';
let { WizModal, WizSurveyAudience, WizTypography, WizRow ,WizDataTable,WizButton} = component_tool;
let { $$, checkStrLength } = utils_tool;
import { WizClassifySelect } from '../../common'
import HighSet from "@/containers/common/highSet";
import React from 'react'
import {WizTableForm} from "../../common";
const categoryConfig = WizTableForm.Config.categoryInfo(this, {apiParams: {type: 13, state: 1}})

//配置项
let componentName = 'cert'

const columns =(self)=>{
  return [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "证书名称",
    name: "name",
    dataIndex: "name",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "证书分类",
    name: "categoryStr",
    dataIndex: "categoryStr",
    tableItem: {}
  },
  {
    title: '证书分类',
    name: 'category',
    searchItem: {
      ...categoryConfig,
      diy: WizTableForm,
      selectType: 'radio',
    },
  },
  {
    title: "证书类型",
    name: "classify",
    dataIndex: "classify",
    tableItem: {},
    dict: [
      { code: 1, codeName: "个人" },
      { code: 2, codeName: "店端" }
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "证书类别",
    name: "type",
    dataIndex: "type",
    tableItem: {},
    dict: [
      { code: 1, codeName: "培训证书" },
      { code: 2, codeName: "社会证书" }
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 0, codeName: "无效" },
      { code: 1, codeName: "有效" }
    ],
    searchItem: {
      type: "select"
    },

  },
  {
    title: '关联内容',
    name: 'content',
    tableItem: {
      render: (text, record) => (
        <WizDataTable.Oper>
          <WizButton tooltip={'查看详情'} disabled={record.type==2}
            onClick={() => {
              self._btnShowRelationContentFun && self._btnShowRelationContentFun(record)
            }}>
            {'查看详情'}
          </WizButton>
        </WizDataTable.Oper>
      )
    }
  },
];
} 

const templateConfig =(self)=>{ 
  return {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns:columns(self),
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 8
        },
        buttonSort: ['add',"export"],
        buttons: [
          {
            key: "add",
            custom: true,
            params: { icon: "plus", children: "新增", type: "primary"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/cert/certList/certAdd"
              }
            }

          },
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false,
        // expandedRowRender: (record) => {
        //   return (
        //     <>
        //       <WizRow>
        //         <WizTypography.Paragraph strong>证书受众：</WizTypography.Paragraph>
        //       </WizRow>
        //       <WizSurveyAudience surveyAudienceTitle={"适用范围"} labelWidth={4} style={{ width: '90%' }}  data={record['authData'] || {}} />
        //     </>
        //   )
        // }
      },
      showAuth: {
        title: '适用范围',
        dataIndex: 'authData'
      },
      showAuthnew: {
        title: '适用范围1',
        dataIndex: 'state'
      },
      rowOperateSort: ['look','update', 'enableOrDisable','advancedSet'],
      rowOperateView: [
        {
          key: 'look',
          custom: true,
          params: { children: '查看'},
          customOnClick: {
            key: 'jumpPage',
            params: {
              key: 'push',
              pathname: '/cert/certList/certInfo'
            }
          }
        },
        {
          key: "update",
          custom: true,
          params: { children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/cert/certList/certUpd"
            }
          }
        },
        {
          key: "enableOrDisable",
          custom: true,
          params: {},//状态  0无效  1有效
          textFormat: {
            recordKey: 'state',
            dirt: {  1: '禁用', 0: '启用' }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "updateState",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['state'] === 0 ? "启用" : "禁用"
                }该证书？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record['state'] === 1 ? 0 : 1,
                    id: record['id']
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: 'advancedSet',
          custom: true,
          params: { children: '高级设置' },
          customOnClick: {
            key: 'modal',
            params: {
              modalParams: {
                title: '高级设置',
                bordered: true,
                footer: null,
                destroyOnClose: true,
                diy: (e) => {
                  //BIZ_APPLY = 15;
                  return <>
                    <HighSet data={{ record: e.record, bizType: 21 }}
                      changeModal={e.changeModal}
                    />
                  </>
                },
                width: 950
              },
            }
          },
          recordChangeParams: ({ record, rows }) => {
            let disabled = false
            if ((record && record['state'] !== 1)|| record.type==2 ) {
              disabled = true
            }
            return { disabled }
          }
        }

      ],
      commonOperate: {
        add: true,
        delete: true,
        update: true

      }
    }
  }
}
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  }
  ,
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  updateState: {
    path: `${componentName}/updateState`,
    payload: {
      key: `${componentName}@updateState`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
